import React from "react";
import { createTheme } from "@material-ui/core";
import { useMemo } from "react";
import { LocalizationTheme } from "../../../../../utils/utils";

import { DeleteOutline, Edit } from "@material-ui/icons";

const tableTheme = createTheme({
  ...LocalizationTheme(),
  palette: {
    ...LocalizationTheme().palette,
    primary: {
      ...LocalizationTheme().palette.primary,
      main: "#53B3EA",
    },
  },
});

function useSignableDocumentsTableConfig(resources, onEdit, onDelete) {

  const columns = useMemo(() => {
    return [
      {
        title: resources["Description"],
        field: "description",
      },
      {
        title: resources["Language"],
        field: "language",
      },
      {
        title: resources["Outlet"],
        field: "outletDescription",
      },
      {
        title: resources["IsActive"],
        field: "isActive",
      },
    ];
  }, []);

  const baseActions = [
    {
      icon: () => <Edit />,
      tooltip: resources["EditTooltip"],
      onClick: (_, rowData) => {
        onEdit(rowData.id);
      },
    },
  ];

  const additionalActions = [
    {
      icon: () => <DeleteOutline />,
      tooltip: resources["Delete"],
      onClick: (_, rowData) => onDelete(rowData.id),
    },
  ];

  const actions = [...baseActions, ...additionalActions];

  const options = {
    emptyRowsWhenPaging: false,
    pageSize: 10,
    pageSizeOptions: [10, 15, 20],
  };

  return {
    tableTheme,
    columns,
    actions,
    options,
  };
}

export default useSignableDocumentsTableConfig;
